<app-master-list
  class="master-list"
  [items]="trackedTimes"
  [headers]="headers"
  [sortByHeader]="sortByHeader$ | async"
  [noItemsOptions]="noTrackedTimeOptions$ | async"
  [lastPageFetched]="lastPageFetched$ | async"
  [fetchingList]="fetchingList$ | async"
  [enablePagination]="true"
  [hasFilters]="true"
  [fetchingFilterTotals]="fetchingListFilters$ | async"
  [filterOptions]="yearFilterOptions$ | async"
  [selectedFilter]="selectedYearFilter$ | async"
  [filterTotalsLabel]="'LABEL.TOTAL' | translate"
  [filterTotals]="filterTotals$ | async"
  [groupByFn]="groupByFn$ | async"
  [groupMetadata]="groupMetadata$ | async"
  (onInfinitePagination)="fetchNextPage()"
  (onToggleSorting)="sortList($event)"
  (onFilterList)="filterList($event)"
  (onNoItemsPrimaryActionClick)="trackTime()"
>
  <ng-template let-trackedTime="entity" let-position="position">
    <app-tracked-time-list-item
      *ngIf="position"
      [trackedTime]="trackedTime"
      [position]="position"
      (onAction)="onQuickAction($event, trackedTime)"
    >
    </app-tracked-time-list-item>
  </ng-template>
</app-master-list>
